module.exports = __webpack_public_path__ + "9f9a1e16047b82cc7ebe36c7baad656a.svg";